import React from 'react';
import { inject, observer } from 'mobx-react';
export var LoginPanel = inject('userStore')(observer(function (_ref) {
  var userStore = _ref.userStore,
      children = _ref.children;

  if (userStore.user.id) {
    return null;
  } else {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        margin: 'auto',
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-fluid"
    }, children));
  }
}));